/** @jsxImportSource @emotion/react */
import { useEffect, useState } from "react";
import { Skeleton } from "primereact/skeleton";
import { Divider } from "primereact/divider";
import { Column } from "primereact/column";
import {
  accessAPI,
  formatFechaHora,
  ArchivoPreview,
  CampoInformacion,
  TablaFiltrable,
  Titulo
} from "../../shared";

/**
 * Contenido completo de un correo de la casilla del historial: remitente,
 * destinatarios, adjuntos con vista previa y texto. Se usa dentro de un Sidebar.
 *
 * @param {Object} props
 * @param {number} props.correoId
 * @param {Object} props.toast - ref de Toast para avisar errores
 */
export default function VisorCorreo({ correoId, toast }) {
  const [correo, setCorreo] = useState(null);

  useEffect(() => {
    setCorreo(null);
    if (!correoId) return;
    accessAPI(
      "GET",
      `admin/comunicacioncliente/correo/${correoId}`,
      null,
      (respuesta) => setCorreo(respuesta),
      () =>
        toast?.current?.show({
          severity: "error",
          summary: "Error",
          detail: "No se pudo cargar el correo"
        })
    );
  }, [correoId, toast]);

  if (!correo) {
    return (
      <div css={{ display: "flex", flexDirection: "column", gap: "1em" }}>
        <Skeleton width="80%" height="1.5rem" />
        <Skeleton width="100%" height="20rem" />
      </div>
    );
  }

  return (
    <div>
      <Titulo>{correo.asunto || "(sin asunto)"}</Titulo>
      <CampoInformacion nombreCampo="Fecha">
        {formatFechaHora(correo.fecha || correo.fechaRecepcion)}
      </CampoInformacion>
      <CampoInformacion nombreCampo="De">{correo.de}</CampoInformacion>
      <CampoInformacion nombreCampo="Para">{correo.para.join(", ") || "-"}</CampoInformacion>
      {correo.cc.length > 0 && <CampoInformacion nombreCampo="CC">{correo.cc.join(", ")}</CampoInformacion>}
      {correo.adjuntos.length > 0 && (
        <div css={{ marginTop: "1em" }}>
          <TablaFiltrable conFiltros={false} value={correo.adjuntos} size="small">
            <Column
              header="Adjuntos"
              body={(a) => <ArchivoPreview nombre={a.nombre} hash={a.hash} />}
              exportValue={(a) => a.nombre}
            />
          </TablaFiltrable>
        </div>
      )}
      <Divider />
      <div css={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{correo.texto || "(sin texto)"}</div>
    </div>
  );
}
